import * as React from 'react';
import classnames from 'classnames';
import snakeCase from 'lodash/snakeCase';

import Link from 'libs/router/Link';
import EntityAvatar from 'components/entity/entity-avatar/EntityAvatar';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';
import Tooltip from 'components/Tooltip';

import { __t, applyTranslations } from 'utils/language';
import { expandDataProps } from 'utils/helper/common';
import { getOrganizationProfileIfExist } from 'utils/organization';
import { getDefaultOrganizationSettingsUrl } from 'utils/navigation';
import { getOrganizationType } from './utils/utils';

import './user-dropdown-item.scss';

import type { Account, Data, Organization, OrganizationWithEntity } from 'types';

applyTranslations(require('./user-dropdown-item.i18n.json'));

type OwnProps = {
  organization: OrganizationWithEntity,
  onClick: (a: React.SyntheticEvent<HTMLAnchorElement | HTMLDivElement>) => void,
  data?: Data | null,
  currentAccount: Account | undefined | null,
  currentOrganization: Organization | undefined | null
};

type Props = OwnProps;

const OTHER_AVATAR_SIZE = { width: 24, height: 24 };

class UserDropdownItem extends React.PureComponent<Props> {
  handleLinkClicked = (event: React.SyntheticEvent<HTMLAnchorElement>) => {
    const { onClick } = this.props;

    event.stopPropagation();
    onClick(event);
  };

  render() {
    const {
      currentOrganization,
      organization,
      onClick,
      data
    } = this.props;

    const entity = organization.entity;
    const activeProfile = getOrganizationProfileIfExist(organization);
    const orgType = snakeCase(getOrganizationType(organization));
    const senttingsTooltipType = orgType === 'approved_brand'
      ? 'brand_settings'
      : `${orgType}_settings`;

    const classes = classnames({
      'user-dropdown-item': true,
      'user-dropdown-item--active': currentOrganization && organization.id === currentOrganization.id
    });

    return (
      <div
        className={classes}
        onClick={onClick}
        data-arg={organization.id}
        {...expandDataProps(data)}
      >
        <div className="user-dropdown-item__row">
          <Tooltip
            message={__t(`user_dropdown_item.tooltip.${orgType}`)}
            width="auto-compact"
          >
            <EntityAvatar
              bordered
              isClickable
              entity={entity}
              customSize={OTHER_AVATAR_SIZE}
            />
          </Tooltip>
          <Tooltip
            message={__t(`user_dropdown_item.tooltip.${orgType}`)}
            width="auto-compact"
            classNameWrapper="text-overflow-ellipsis"
          >
            <span
              className="user-dropdown-item__label"
              title={entity.displayName}
            >
              {entity.displayName}
            </span>
          </Tooltip>
          <Link
            to={getDefaultOrganizationSettingsUrl(organization)}
            onClick={this.handleLinkClicked}
            data-arg={organization.id}
            className="user-dropdown-item__link"
            title={activeProfile
              ? __t('user_dropdown_item.ser_dropdown_settings')
              : __t('user_dropdown_item.user_dropdown_create_profile')}
          >
            <Tooltip
              message={__t(`user_dropdown_item.tooltip.${senttingsTooltipType}`)}
              width="auto-compact"
            >
              <SVGDynamicIcon
                width={16}
                height={16}
                name="gear-custom-bg"
                customColor="grey"
              />
            </Tooltip>
          </Link>
        </div>
      </div>
    );
  }
}

export default UserDropdownItem;
